import { toInteger } from 'lodash';

export const computeFullScreenWatermarkSize = (
    scale: number,
    image: { width: number; height: number },
    stage: { width: number; height: number },
) => {
    // const DEFAULT = 0.5; //默认放大1.3倍
    let width = 0;
    let height = 0;
    if (stage.width > stage.height) {
        const s = image.width / image.height;
        width = toInteger(image.width * scale);
        height = toInteger(width / s);
    } else {
        const s = image.height / image.width;
        height = toInteger(image.height * scale);
        width = toInteger(height * s);
    }
    if ((image.width > image.height && width < height) || (image.height > image.width && height < width)) {
        const x = height;
        height = width;
        width = x;
    }
    return {
        width,
        height,
    };
};

/**
 * 计算水印位置
 *
 * @param imgSize - 水印图片尺寸
 * @param stageSize - 舞台尺寸
 */
export const computedPosition = (
    imgSize: { width: number; height: number },
    stageSize: { height: number; width: number },
) => {
    let imgWidth: number = 0;
    let imgHeight: number = 0;
    const scale = imgSize.width / imgSize.height;
    if (stageSize.height > stageSize.width) {
        imgWidth = stageSize.width / 4;
        imgHeight = imgWidth / scale;
    } else {
        imgHeight = stageSize.height / 4;
        const scale = imgSize.width / imgSize.height;
        imgWidth = imgHeight * scale;
    }
    const top = (stageSize.height - imgHeight) * 0.9;
    const left = (stageSize.width - imgWidth) * 0.9;
    return {
        width: imgWidth,
        height: imgHeight,
        top,
        left,
    };
};
